// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1syyY","question":"Question_question__3-nLl","description":"Question_description__3Y3L9"};